import React from 'react';
import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select
} from '@mui/material';

/**
 * A reusable multi-select dropdown component without a label
 * 
 * @param {Object} props - Component props
 * @param {Array} props.options - Currently selected options
 * @param {Function} props.onChange - Function to call when selection changes
 * @param {Function} props.renderValue - Function to render the selected values display
 * @param {Object} props.itemMap - Mapping of option keys to display text
 * @param {string} props.backgroundColor - Background color for the select component
 */
export const MultiSelect = ({
  options,
  value,
  onChange,
  renderValue,
  itemMap,
  backgroundColor,
  sortAlphabetically = false
}) => {
  const handleChange = (event) => {
    const { value } = event.target;
    onChange(value);
  };

  // Default rendering for all filters
  const renderMenuItems = () => {
    const entries = Object.entries(itemMap);
    if (sortAlphabetically) entries.sort(([, a], [, b]) => a.localeCompare(b));
    return entries.map(([key, name], index) => {
      const isWet = key === 'WET';
      const isBroth = key === 'BROTH';
      
      return (
        <MenuItem 
          key={key} 
          value={key} 
          className="filter-menu-item"
          sx={isWet ? {
            borderBottom: '1px solid #e0e0e0',
            paddingBottom: '3px'
          } : {}}
        >
          <Checkbox 
            checked={value.indexOf(key) > -1} 
            className="filter-checkbox"
          />
          <ListItemText primary={name} />
        </MenuItem>
      );
    });
  };

  return (
    <FormControl size="small" className="filter-select-container" fullWidth>
      <Select
        multiple
        value={value}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 300 },
          },
          disableScrollLock: true, // Prevents layout shift caused by scroll lock
        }}
        className="filter-select"
        displayEmpty
        sx={{
          backgroundColor: backgroundColor || 'transparent'
        }}
      >
        {renderMenuItems()}
      </Select>
    </FormControl>
  );
};